import { createStore, applyMiddleware } from "redux";
import { routerMiddleware } from "react-router-redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import rootReducer from "./reducers";

export const history = createBrowserHistory();

const initialState = {};

let enhancers = [thunk, routerMiddleware(history)]

if(window._env.NODE_ENV !== 'production'){
    enhancers = [...enhancers, createLogger()];
}

export const store = createStore(rootReducer, initialState, applyMiddleware(...enhancers));